import { jwtDecode } from "jwt-decode";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { StackActions, NavigationProp } from "@react-navigation/native";
import { toast } from "react-toastify";
import { AppScreens } from "../../screens/Utility/AppScreens";
import { base_url, endpoints } from "../../Api/configs";
import { clearAllCaches } from "../cacheManager";
import { logoutUser } from "../../services/authAPI";

interface DecodedToken {
  exp: number;
  [key: string]: any;
}

const isTokenExpired = (token: string): boolean => {
  const decodedToken: DecodedToken = jwtDecode(token);
  const currentTime = Math.floor(Date.now() / 1000);
  return decodedToken.exp < currentTime;
};

interface UserLogoutAPIProps {
  bodyParams: { accessToken: string };
  success: (data: any) => void;
}

export const checkAndHandleTokenExpiration = async (
  navigation: NavigationProp<any>
): Promise<boolean> => {
  try {
    const jsonValue = await AsyncStorage.getItem("@loginData");
    let data = jsonValue ? JSON.parse(jsonValue) : null;

    if (data != null) {
      const { AccessToken } = data;
      if (isTokenExpired(AccessToken)) {
        console.log('⚠️ Token expired, logging out user...');

        const params = { accessToken: AccessToken };

        // Call logout API without waiting (fire and forget)
        logoutUser(params).then((response) => {
          if (response.statusCode === 200) {
            console.log("Logout API success:", response.body?.message);
          }
        }).catch((apiError) => {
          console.error("Logout API error:", apiError);
        });

        // Clear all caches when token expires
        await clearAllCaches();

        // Set flag for showing session expired message
        sessionStorage.setItem('showSessionExpiredToast', 'true');

        // Force a full page reload to clear all state
        window.location.href = window.location.origin + '/login';

        return false;
      }

      return true;
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
};

export function userLogoutAPI({
  bodyParams,
  success,
}: UserLogoutAPIProps): void {
  fetch(base_url + endpoints.auth.logout, {
    mode: "cors",
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      body: bodyParams,
    }),
  })
    .then(async function (data) {
      const response = await data.json();
      const statusCode = data.status;

      if (statusCode === 200) {
        success(response.body);
      } else if (statusCode === 400) {
        toast.error("Bad Request");
      } else if (statusCode > 400 && statusCode < 420) {
        toast.error("Unauthorized");
      } else if (statusCode >= 500) {
        toast.error("Internal Server Error");
      }
    })
    .catch((error) => {
      toast.error(error.message);
    });
}
